import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wind, LogOut, LayoutDashboard, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";

export function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 glass border-b border-slate-200" data-testid="app-header">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <div className="h-9 w-9 rounded-2xl bg-sky-600 flex items-center justify-center shadow-sm group-hover:rotate-12 transition-transform duration-300">
            <Wind className="h-5 w-5 text-white" />
          </div>
          <div className="leading-none">
            <div className="font-head text-lg font-extrabold tracking-tight text-slate-900">
              Meteo<span className="text-sky-600">Seba</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" />
              <span className="text-[10px] uppercase tracking-widest font-bold text-slate-400">
                Vento Lago di Garda
              </span>
            </div>
          </div>
        </Link>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button
                variant="ghost"
                onClick={() => navigate("/admin")}
                data-testid="admin-panel-btn"
                className="rounded-full font-semibold text-slate-700"
              >
                <LayoutDashboard className="h-4 w-4 mr-1.5" /> Pannello Seba
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                data-testid="logout-btn"
                className="rounded-full"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <Button
              onClick={() => navigate("/login")}
              data-testid="login-nav-btn"
              className="rounded-full bg-sky-600 hover:bg-sky-700 font-semibold"
            >
              <LogIn className="h-4 w-4 mr-1.5" /> Area Seba
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
